/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Logo_RequirementsInputs */

const vi_invoice_logo_requirements = /** @type {(inputs: Invoice_Logo_RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ảnh PNG, JPEG hoặc WebP, tối đa 2 MB.`)
};

/**

* @param {Invoice_Logo_RequirementsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_logo_requirements = /** @type {((inputs?: Invoice_Logo_RequirementsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Logo_RequirementsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_logo_requirements(inputs)
});